import { registerHandler } from '../paymentHandlerRegistry';

/**
 * Pix payment handler.
 * Handle Pix transfer payments by calling transferPaymentAttempt directly.
 * PixForm is informational-only (no redux-form registered), so the payment
 * action is dispatched without form data, matching the regular Checkout behavior.
 */
const pixPaymentHandler = {
  canHandle: ({ selectedPaymentMethod }) => selectedPaymentMethod?.provider === 'pix',

  execute: async ({ purchase, onTransferPaymentAttempt }) => {
    const { token, selectedPaymentMethod } = purchase;
    onTransferPaymentAttempt({
      purchaseToken: token,
      engine: selectedPaymentMethod?.engine,
      provider: selectedPaymentMethod?.provider,
    });
  },
};

// Register for both 'transfer' (transfer+pix provider) and 'pix' (legacy standalone)
registerHandler('transfer', pixPaymentHandler);
registerHandler('pix', pixPaymentHandler);
